import queryString from 'query-string';

import ApiService from '../../../shared/services/ApiService';
import {
  SearchChoiceResponse,
  FetchPlansParams,
  FetchPlansResponse,
  FavorResponse,
  DisfavorResponse,
  FetchV2PlansResponse,
} from './types';

// TODO: /api/v1/plans に移行する
const API_PLANS = '/api/plans';
const API_V1_PLAN_FAVOR = '/api/v1/plans/:planId/favor';
const API_V1_PLAN_DISFAVOR = '/api/v1/plans/:planId/disfavor';
const SEARCH_CHOICE = '/api/v1/plans/search_choice';
const API_V2_PLANS = '/api/v2/plans';
const API_V2_PLAN_FAVORITES = '/api/v2/plans/favorites';

class PlanApiService extends ApiService {
  public fetchPlans(
    params: Partial<FetchPlansParams> = {},
  ): Promise<FetchPlansResponse> {
    const queryStr = queryString.stringify(params, { arrayFormat: 'comma' });
    return this.request(
      `${API_PLANS}${queryStr ? `?${queryStr}` : ''}`,
      this.METHOD.GET,
    );
  }

  public fetchV2Plans(
    params: Partial<FetchPlansParams> = {},
  ): Promise<FetchV2PlansResponse> {
    const queryStr = queryString.stringify(params, { arrayFormat: 'comma' });
    return this.request(
      `${API_V2_PLANS}${queryStr ? `?${queryStr}` : ''}`,
      this.METHOD.GET,
    );
  }

  public fetchV2Favorites(
    params: Partial<{ plan_id: number[] }> = {},
  ): Promise<number[]> {
    const queryStr = queryString.stringify(params, { arrayFormat: 'comma' });
    return this.request(
      `${API_V2_PLAN_FAVORITES}${queryStr ? `?${queryStr}` : ''}`,
      this.METHOD.GET,
    );
  }

  public fetchSearchChoice(): Promise<SearchChoiceResponse> {
    return this.request(SEARCH_CHOICE, this.METHOD.GET);
  }

  public favor(planId: number): Promise<FavorResponse> {
    return this.request(
      API_V1_PLAN_FAVOR.replace(':planId', String(planId)),
      this.METHOD.POST,
    );
  }

  public disfavor(planId: number): Promise<DisfavorResponse> {
    return this.request(
      API_V1_PLAN_DISFAVOR.replace(':planId', String(planId)),
      this.METHOD.POST,
    );
  }
}

export default PlanApiService;
